import clsx from 'clsx';

export const section = clsx(
  'px-10',
  'py-20',
  'md:px-48',
  'md:pl-0',
  'md:pr-0',
  'md:py-0',
  'bg-background',
  'text-center'
);

export const container = clsx(
  'flex',
  'flex-col',
  'md:flex-row',
  'items-center'
);

export const image = clsx(
  'md:max-w-[50%]',
  'mb-10',
  'md:mb-0',
  'object-contain'
);

export const mobileImage = clsx(
  'rounded-2xl',
  'shadow-lg',
  'w-full',
  'max-w-72',
  'md:max-w-md',
  'mb-10',
  'md:mb-0',
  'object-contain'
);

export const content = clsx(
  'flex',
  'flex-col',
  'left-[35%]',
  'absolute',
  'max-w-[50%]'
);

export const mobileContent = clsx('flex', 'flex-col');

export const titleText = clsx(
  'title',
  'text-[26px]',
  'md:text-3xl',
  'font-semibold',
  'mb-6',
  'text-title',
  'text-center',
  'md:text-left'
);

export const auxTitleText = clsx(
  'title',
  'text-[26px]',
  'md:text-3xl',
  'font-semibold',
  'mb-0',
  'text-title',
  'text-center',
  'md:text-left'
);

export const descriptionText = clsx(
  'font-subtitle',
  'text-[14px]',
  'md:text-[15px]',
  'text-description',
  'text-center',
  'md:text-left',
  'tracking-normal'
);

export const button = clsx(
  'title',
  'inline-flex',
  'flex-row',
  'items-center',
  'justify-center',
  'gap-1.5',
  'bg-title',
  'text-white',
  'text-sm',
  'font-regular',
  'rounded-full',
  'shadow',
  'hover:opacity-90',
  'mt-6',
  'md:self-start',
  'self-center',
  'w-60',
  'h-12'
);

export const buttonsContainer = clsx('mt-6', 'flex', 'flex-col');
